module.exports = __webpack_public_path__ + "img/甘肃.0e27777a.png";